<template>
	<div>
		<div class="actDiv">
			<a-auto-complete  style="width: 12rem;margin-right: 0.625rem;font-size: 0.6875rem;" v-model="name"  :data-source="completeDataSource"
										placeholder="请输入小区名称" @change="getAutoComplate" allowClear>
			</a-auto-complete>
			<a-button size="small"   icon="search" @click="queryDataList" style="margin: 0 0.625rem;">查询</a-button>
			<a-button size="small"   icon="plus" @click="addNeighborFlag = true">新增</a-button>
			<a-button size="small"   icon="download" @click="exportNeighbors" style="margin-left: 0.625rem;">导出</a-button>
		</div>
		<a-table  size="small" :columns="columns" :data-source="list" bordered :loading="loading"  rowKey="pId"
						:pagination="false"  :scroll="{y:600}" @expand="expandRowHandler" :expandedRowKeys="expandedRowKeys">
			<span slot="mainMeterSlot"  slot-scope="text, record">
				{{record.mainMeter ==1 ? '有' : '无'}}
			</span>
			<span slot="timerSwitchSlot" slot-scope="text, record">
				{{record.timerSwitch ==1 ? '开' : '关'}}
			</span>
			<span slot="timeSlot" slot-scope="text, record">
				{{getTimeFormatter(record.createTime)}}
			</span>
			<span slot="theAction" slot-scope="text, record">
			      <a-button size="small" type="link" @click="editContent(record)">修改</a-button>
				  <a-popconfirm title="确定要删除该条记录?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteContent(record)">
					  <a-button size="small"  type="link">删除</a-button>
				  </a-popconfirm>
				  <a-button size="small"  type="link" @click="addNewGprs(record)">添加集中器</a-button>
				  <a-tooltip placement="top">
				  	<template #title>一键更新该小区所有表的扣费读数为当前表读数</template>
				  	<a-button size="small" type="link" v-show="canUpdateDeRead" @click="updateDeRead(record)">更新扣费读数</a-button>
				  </a-tooltip>
			</span>
			<a-table rowKey = "pId"  size="small"  slot="expandedRowRender" slot-scope="text" :columns="innerColumns" :data-source="gprsList" :pagination="false">
					<span slot="protocolSlot"  slot-scope="text, record">
						{{getProtocolName(record.gprsProtocol)}}
					</span>
					<span slot="historyFlagSlot" slot-scope="text, record">
						{{record.historyFlag == '1' ? '开':'关'}}
					</span>
					<span slot="theChildAction" slot-scope="text, record">
						<a-popconfirm title="表地址和采集器地址将转换至标准协议?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="meterTransformer(record)">
							<a-button size="small" type="link">表转换</a-button>
						</a-popconfirm>
						<a-popconfirm title="更新地址池?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deliveryAddress(record)">
							<a-button size="small"  type="link">下发地址</a-button>
						</a-popconfirm>
						<a-button size="small" v-if="checkGprsCollect(record)"  type="link" @click="showCollectors(record)">采集器</a-button>
						<a-button size="small" type="link" @click="editGprs(record)">修改</a-button>
						<a-button v-if="record.gprsProtocol == 9" size="small"  type="link" @click="showConfigPeriod(record)">设置周期</a-button>
						<a-popconfirm title="确定要删除该条记录?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteGprs(record)">
							<a-button size="small"  type="link">删除</a-button>
						</a-popconfirm>
						<a-button size="small" type="link" @click="changeHistoryFlag(record)">{{record.historyFlag == '1'?'关闭抄历史':'开启抄历史'}}</a-button>
						<a-popconfirm title="确定要重启集中器?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="rebootGPRS(record)">
							<a-button size="small"  type="link" :loading="restartLoading && theGprs == record" v-if="record.gprsProtocol == 9">重启集中器</a-button>
						</a-popconfirm>
					</span>
			</a-table>
		</a-table>
		<a-drawer title="添加小区" :visible="addNeighborFlag" :mask = "false"  width="500" @close="addNeighborClose" :destroyOnClose='true' :maskClosable="false">
			<AddNewNeighbor @cancelAdd="addNeighborClose" @refreshList="queryDataList"/>
		</a-drawer>
		<a-drawer title="修改小区" :visible="editNeighborFlag" :mask = "false"  width="500" @close="editNeighborClose" :destroyOnClose='true' :maskClosable="false">
			<EditNeighbor @cancelEdit="editNeighborClose" @refreshList="queryDataList" :theObj="theObj"/>
		</a-drawer>
		<a-drawer title="添加集中器" :visible="addGprsFlag" :mask = "false"  width="500" @close="onAddClose" :destroyOnClose='true' :maskClosable="false">
			<AddNewGprs :neighborId="theObj.pId" @cancelAdd="onAddClose" @refreshList="queryDataList" @refreshGprs="queryGprsList"/>
		</a-drawer>
		<a-drawer title="修改集中器" :visible="editGprsFlag" :mask = "false"  width="500" @close="onEditClose" :destroyOnClose='true' :maskClosable="false">
			<EditGprs  :theObj="theGprs"  @cancelEdit="onEditClose" @refreshList="queryGprsList"/>
		</a-drawer>
		<a-drawer title="采集器信息" :visible="collectorsFlag" :mask = "false"  width="500" @close="showCollectorsClose" :destroyOnClose='true' :maskClosable="false">
			<ShowCollectors  :theObj="theGprs"   @refreshList="queryGprsList"/>
		</a-drawer>
		<a-drawer title="配置抄表周期"  :visible="configFlag" width="600"  @close="onConfigClose" :destroyOnClose='true' :maskClosable="false">
			<ConfigMeterReadPeriod :theObj="theGprs" @cancelConfig="onConfigClose"/>
		</a-drawer>
	</div>
</template>

<script>
const  columns = [
		{
			title: '小区名',
			dataIndex: 'neighborName',
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '地址',
			dataIndex: 'neighborAddr',
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '管理表',
			dataIndex: 'mainMeter',
			align:'center',
			scopedSlots: { customRender: 'mainMeterSlot' },
			className:'v-cell',
			align:'center',
		},
		{
			title: '定时抄表开关',
			dataIndex: 'timerSwitch',
			align:'center',
			scopedSlots: { customRender: 'timerSwitchSlot' },
			className:'v-cell',
			align:'center',
		},
		{
			title: '定时抄表时间',
			dataIndex: 'timer',
			className:'v-cell',
			align:'center',
		},
		{
			title: '抄表IP',
			dataIndex: 'ip',
			className:'v-cell',
			align:'center',
		},
		{
			title: '备注',
			dataIndex: 'remark',
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '册本号',
			dataIndex: 'bookNum',
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '创建时间',
			width:160,
			dataIndex: 'createTime',
			scopedSlots:{customRender:'timeSlot'},
			className:'v-cell',
			align:'center',
		},
		{
			title: '水表总数',
			width:100,
			dataIndex: 'totalMeterCount',
			className:'v-cell',
			align:'center',
		},
		{
			title: '操作',
			width:300,
			dataIndex: 'pId',
			scopedSlots: { customRender: 'theAction' },
			className:'v-cell',
			align:'center',
		},	
];
const innerColumns=[
	{
		title: '集中器SIM',
		dataIndex: 'gprsTel',
		width:130,
		className:'v-cell',
		align:'center',
	},
	{
		title: '集中器地址',
		dataIndex: 'gprsAddr',
		width:130,
		className:'v-cell',
		align:'center',
	},
	{
		title: '安装地址',
		dataIndex: 'installAddr',
		width:140,
		ellipsis:true,
		className:'v-cell',
		align:'center',
	},
	{
		title: '使用协议',
		dataIndex: 'gprsProtocol',
		scopedSlots: { customRender: 'protocolSlot' },
		width:80,
		className:'v-cell',
		align:'center',
	},
	{
		title: '监听IP',
		dataIndex: 'ip',
		width:80,
		className:'v-cell',
		align:'center',
	},
	{
		title: '监听端口',
		dataIndex: 'port',
		width:80,
		className:'v-cell',
		align:'center',
	},
	{
		title: '备注',
		dataIndex: 'remark',
		width:120,
		ellipsis:true,
		className:'v-cell',
		align:'center',
	},
	{
		title: '抄历史开关',
		dataIndex: 'historyFlag',
		width:120,
		className:'v-cell',
		align:'center',
		scopedSlots: { customRender: 'historyFlagSlot' },
	},
	{
	    title: '操作',
	    key: 'pId',
	    scopedSlots: { customRender: 'theChildAction' },
		width:200,
		className:'v-cell',
		align:'center',
	  },
];
	import AddNewGprs from '../components/AddNewGprs.vue'
	import AddNewNeighbor from '../components/AddNewNeighbor.vue'
	import EditNeighbor from '../components/EditNeighbor.vue'
	import EditGprs from '../components/EditGprs.vue'
	import ShowCollectors from '../components/ShowCollectors.vue'
	import ConfigMeterReadPeriod from '../components/ConfigMeterReadPeriod.vue'
	export default{
		components:{
			AddNewGprs,
			AddNewNeighbor,
			EditNeighbor,
			EditGprs,
			ShowCollectors,
			ConfigMeterReadPeriod,
		},
		data(){
			return {
				columns,
				innerColumns,
				name:null,
				loading:true,
				addNeighborFlag:false,
				addGprsFlag:false,
				editNeighborFlag:false,
				editGprsFlag:false,
				collectorsFlag:false,
				configFlag:false,
				list:[],
				neighborList:[],
				gprsList:[],
				theObj:{},
				theGprs:{},
				expandedRowKeys:[],
				completeDataSource:[],
				restartLoading:false,
				canUpdateDeRead:false,
			}
		},
		methods:{
			updateDeRead(row){
				this.loading = true;
				let nbeighborId = row.pId;
				let param = {
					neighborId:nbeighborId
				};
				let url = this.Api.getLastUrl(this.Api.UPDATE_DEREAD_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('扣费读数更新成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			rebootGPRS:function(record){
				this.restartLoading = true;
				this.theGprs = record;
				let url = this.Api.getLastUrl(this.Api.READ_METER_REBOOT_GPRS_URL);
				let param = {gprsAddr:this.theGprs.gprsAddr};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.restartLoading = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.restartLoading = false;
					console.log(error);
				});
			},
			changeHistoryFlag:function(record){
				let param = {historyFlag:record.historyFlag,gprsId:record.pId};
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_CHANGE_GPRS_HISTORY_FLAG_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.queryGprsList();
						if(record.historyFlag == '0'){
							this.$message.info('需重新配置周期')
							this.showConfigPeriod(record);
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			getAutoComplate:function(){
				this.completeDataSource = [];
				for(var i = 0;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if(item.neighborName.indexOf(this.name)!=-1){
						this.completeDataSource.push(item.neighborName);
					}
				}
			},
			getTimeFormatter:function(dateTime){
				if(dateTime == null){
					return "";
				}else{
					let date = new Date(dateTime);
					return this.Config.formatDate(date);
				}
			},
			editContent:function(item){
				this.theObj = this.Config.deepClone(item);
				this.editNeighborFlag = true;
			},
			deleteContent:function(item){
				let param = {neighborId:item.pId};
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_DELETE_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.queryDataList();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			addNewGprs:function(item){
				this.theObj = item;
				this.addGprsFlag = true;
			},
			getProtocolName:function(value){
				return this.Config.getGprsProtocol(value);
			},
			expandRowHandler:function(expand,record){
				this.expandedRowKeys.pop();
				if(expand){
					this.expandedRowKeys.push(record.pId);
					this.theObj = record;
					this.queryGprsList();
				}
			},
			onAddClose:function(){
				this.addGprsFlag = false;
			},
			onEditClose:function(){
				this.editGprsFlag = false;
			},
			addNeighborClose:function(){
					this.addNeighborFlag = false;
			},
			editNeighborClose:function(){
				this.editNeighborFlag = false;
			},
			onConfigClose:function(){
				this.configFlag = false;
			},
			showConfigPeriod:function(item){
				this.configFlag = true;
				this.theGprs = item;
			},
			meterTransformer:function(item){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_TRANSFER_URL);
				let param = {gprsId:item.pId,gprsAddr:item.gprsAddr};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('已转换表个数:'+result);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			deliveryAddress:function(item){
				let url = this.Api.getLastUrl(this.Api.READ_METER_DISPATCH_ADDRESS_URL);
				let param = {gprsAddr:item.gprsAddr};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success(msg,1.5);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			showCollectors:function(item){
				this.theGprs = item;
				this.collectorsFlag = true;
			},
			editGprs:function(item){
				this.theGprs = this.Config.deepClone(item);
				this.editGprsFlag = true;
			},
			showCollectorsClose:function(){
				this.collectorsFlag = false;
			},
			deleteGprs:function(item){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_GPRS_DELETE_URL);
				let param = {theId:item.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.queryGprsList();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			checkGprsCollect:function(item){
				if(item.gprsProtocol == 5 || item.gprsProtocol == 6 || item.gprsProtocol == 9){
					return false;
				}
				return true;
			},
			queryGprsList:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_GPRS_LIST_URL);
				let param = {neighborId:this.theObj.pId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.gprsList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryDataList:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				let param = {name:this.name};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
						if(this.neighborList.length == 0){
							this.neighborList = this.Config.deepClone(result);
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			},
			exportNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_LIST_EXPORT_URL);
				let param = {neighborName:this.name};
				this.Api.fetchPostFile(url,param).then((res)=>{
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = 'neighbor.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
		created() {
			this.queryDataList();
			this.canUpdateDeRead = this.Config.getUserLocal().wcId == 37;
		},
	}
</script>

<style>
</style>
